/* eslint-disable no-unused-vars */
import React, { ReactNode } from 'react'
import { IEvent } from '../types'
import { CALENDAR_TYPE, EVENT_TYPES } from '../constants'
import FlagIcon from './FlagIcon'

export const Left = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.68642 12.6136C9.59868 12.6141 9.5117 12.5973 9.43048 12.5641C9.34925 12.5309 9.27538 12.482 9.21308 12.4202L5.25975 8.47356C5.13793 8.3458 5.06887 8.17674 5.06642 8.00023C5.06591 7.91249 5.08273 7.82551 5.1159 7.74429C5.14908 7.66306 5.19796 7.58919 5.25975 7.52689L9.21308 3.58023C9.34062 3.47101 9.50467 3.41394 9.67245 3.42042C9.84024 3.4269 9.9994 3.49645 10.1181 3.61518C10.2369 3.73391 10.3064 3.89307 10.3129 4.06086C10.3194 4.22864 10.2623 4.39269 10.1531 4.52023L6.66642 8.00023L10.1398 11.4802C10.2639 11.6051 10.3336 11.7741 10.3336 11.9502C10.3336 12.1264 10.2639 12.2953 10.1398 12.4202C10.0189 12.5402 9.85668 12.6094 9.68642 12.6136Z'
      fill='#252F4A'
    />
  </svg>
)

export const Right = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.84715 12.6666C6.75894 12.6662 6.67169 12.6483 6.59044 12.614C6.50919 12.5797 6.43556 12.5295 6.37381 12.4666C6.24965 12.3416 6.17995 12.1727 6.17995 11.9966C6.17995 11.8204 6.24965 11.6515 6.37381 11.5266L9.85381 7.99989L6.37381 4.55322C6.31165 4.49019 6.26252 4.41553 6.22921 4.3335C6.19591 4.25148 6.17908 4.1637 6.1797 4.07517C6.18032 3.98665 6.19837 3.89911 6.23282 3.81756C6.26727 3.73601 6.31744 3.66205 6.38048 3.59989C6.44351 3.53773 6.51817 3.48859 6.6002 3.45529C6.68222 3.42198 6.77 3.40516 6.85853 3.40578C6.94705 3.4064 7.03459 3.42445 7.11614 3.4589C7.19769 3.49334 7.27165 3.54352 7.33381 3.60655L11.2805 7.55989C11.4046 7.6848 11.4743 7.85376 11.4743 8.02989C11.4743 8.20601 11.4046 8.37498 11.2805 8.49989L7.33381 12.4466C7.27224 12.5148 7.19722 12.5696 7.11347 12.6074C7.02972 12.6453 6.93905 12.6654 6.84715 12.6666Z'
      fill='#252F4A'
    />
  </svg>
)

export const Book = ({ color = '#025EFF' }: { color?: string }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.36051 3.61971C6.37671 3.45978 5.3735 3.45977 4.38969 3.61969C4.04645 3.67549 3.70164 3.7585 2.93716 3.94368C2.81469 3.97335 2.74354 3.99072 2.69032 4.00583C2.6569 4.01532 2.64293 4.02058 2.6395 4.02196C2.6395 4.02196 2.6395 4.02196 2.6395 4.02196C2.57147 4.05542 2.52252 4.11776 2.50609 4.19125C2.50556 4.19493 2.50375 4.2097 2.5024 4.24419C2.50024 4.29939 2.50011 4.37254 2.50011 4.49846V15.8196C2.50011 15.9083 2.50015 15.9626 2.50105 16.0033C2.50163 16.0294 2.50244 16.041 2.50265 16.0437C2.52153 16.1749 2.64055 16.2691 2.7739 16.2564C2.7766 16.2559 2.78803 16.254 2.81375 16.2484C2.85362 16.2397 2.90644 16.2269 2.99264 16.206L3.00819 16.2023C3.34117 16.1216 3.52697 16.0766 3.71304 16.0384C5.13954 15.7457 6.61067 15.7457 8.03717 16.0384C8.22321 16.0766 8.40898 16.1216 8.74185 16.2022L9.25011 16.3253V4.04958L8.81305 3.94371C8.04857 3.75852 7.70375 3.6755 7.36051 3.61971ZM10.7501 4.04959V16.3253L11.2582 16.2023C11.5912 16.1216 11.777 16.0766 11.963 16.0384C13.3895 15.7457 14.8607 15.7457 16.2872 16.0384C16.4732 16.0766 16.659 16.1216 16.992 16.2023L17.0076 16.206C17.0938 16.2269 17.1466 16.2397 17.1865 16.2484C17.2256 16.257 17.2317 16.257 17.2242 16.2562C17.3584 16.2701 17.4786 16.1756 17.4976 16.0437C17.4978 16.041 17.4986 16.0294 17.4992 16.0033C17.5001 15.9626 17.5001 15.9083 17.5001 15.8196V4.49852C17.5001 4.37258 17.5 4.29943 17.4978 4.24423C17.4965 4.20973 17.4947 4.19496 17.4941 4.19129C17.4777 4.11779 17.4287 4.05545 17.3607 4.022C17.3573 4.02062 17.3433 4.01536 17.3099 4.00587C17.2567 3.99075 17.1855 3.97338 17.063 3.94372C16.2985 3.75853 15.9537 3.67551 15.6104 3.61972C14.6267 3.45981 13.6235 3.45981 12.6398 3.61972C12.2965 3.67551 11.9517 3.75853 11.1872 3.94372L10.7501 4.04959ZM4.14902 2.13913C5.29223 1.95329 6.45799 1.9533 7.6012 2.13914C8.00774 2.20523 8.41052 2.30281 9.13225 2.47765L9.80168 2.63981C9.87479 2.65752 9.91513 2.66723 9.94602 2.67381C9.97272 2.67949 9.97804 2.67967 9.97581 2.67945C9.99197 2.68102 10.0082 2.68102 10.0244 2.67945C10.0222 2.67967 10.0275 2.67949 10.0542 2.67381C10.0851 2.66723 10.1254 2.65752 10.1985 2.63982L10.868 2.47765C11.5897 2.30281 11.9925 2.20524 12.3991 2.13915C13.5423 1.95333 14.708 1.95333 15.8511 2.13915C16.2577 2.20524 16.6605 2.30281 17.3822 2.47765L17.4162 2.48588C17.4319 2.48969 17.4478 2.4935 17.4637 2.49732C17.6482 2.5417 17.8425 2.58844 18.0149 2.67215C18.4972 2.9064 18.8457 3.34888 18.9599 3.87292C19.0008 4.0602 19.0005 4.26011 19.0002 4.44971C19.0001 4.46606 19.0001 4.48234 19.0001 4.49852V15.8196C19.0001 15.8317 19.0001 15.8438 19.0001 15.8559C19.0003 15.9884 19.0004 16.1238 18.9843 16.2426C18.8576 17.1797 18.0092 17.8457 17.0693 17.7482C16.9501 17.7358 16.8185 17.7038 16.6896 17.6724C16.6779 17.6696 16.6661 17.6667 16.6544 17.6639C16.3018 17.5784 16.1428 17.54 15.9857 17.5078C14.7581 17.2559 13.4921 17.2559 12.2645 17.5078C12.1074 17.54 11.9484 17.5784 11.5958 17.6639L10.5517 17.9168C10.5427 17.9189 10.5337 17.9211 10.5246 17.9233C10.4134 17.9504 10.2943 17.9794 10.1697 17.9915C10.0569 18.0025 9.9433 18.0025 9.83048 17.9915C9.70589 17.9794 9.5868 17.9504 9.47557 17.9233C9.4665 17.9211 9.45749 17.9189 9.44854 17.9168L8.40443 17.6639C8.05182 17.5784 7.89278 17.54 7.7357 17.5078C6.50811 17.2559 5.2421 17.2559 4.01452 17.5078C3.85743 17.54 3.6984 17.5784 3.34578 17.6639C3.33408 17.6667 3.32234 17.6696 3.31058 17.6724C3.18171 17.7038 3.05015 17.7358 2.93091 17.7482C1.991 17.8457 1.14259 17.1797 1.01588 16.2426C0.999808 16.1238 0.999947 15.9883 1.00008 15.8559C1.00009 15.8438 1.00011 15.8317 1.00011 15.8196V4.49846C1.00011 4.48228 1.00008 4.466 1.00005 4.44965C0.999745 4.26006 0.999419 4.06018 1.04026 3.8729C1.15455 3.34885 1.50299 2.90636 1.98536 2.67211C2.15773 2.5884 2.35205 2.54166 2.53655 2.49729C2.55245 2.49346 2.56828 2.48965 2.58402 2.48584L2.61796 2.47762C3.3397 2.30278 3.74248 2.20521 4.14902 2.13913Z'
      fill={color}
    />
  </svg>
)

export const CalendarDelete = ({ color = '#D20306' }: { color?: string }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.75 1C7.16421 1 7.5 1.33579 7.5 1.75V3H12.5V1.75C12.5 1.33579 12.8358 1 13.25 1C13.6642 1 14 1.33579 14 1.75V3H16.25C17.7688 3 19 4.23122 19 5.75V8.75C19 9.16421 18.6642 9.5 18.25 9.5H2.5V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H8.75C9.16421 17.5 9.5 17.8358 9.5 18.25C9.5 18.6642 9.16421 19 8.75 19H3.75C2.23122 19 1 17.7688 1 16.25V5.75C1 4.23122 2.23122 3 3.75 3H6V1.75C6 1.33579 6.33579 1 6.75 1ZM6 4.5H3.75C3.05964 4.5 2.5 5.05964 2.5 5.75V8H17.5V5.75C17.5 5.05964 16.9404 4.5 16.25 4.5H14V5.25C14 5.66421 13.6642 6 13.25 6C12.8358 6 12.5 5.66421 12.5 5.25V4.5H7.5V5.25C7.5 5.66421 7.16421 6 6.75 6C6.33579 6 6 5.66421 6 5.25V4.5ZM12 15.75C12 15.3358 12.3358 15 12.75 15H19.25C19.6642 15 20 15.3358 20 15.75C20 16.1642 19.6642 16.5 19.25 16.5H12.75C12.3358 16.5 12 16.1642 12 15.75Z'
      fill={color}
    />
  </svg>
)

export const CalendarAccept = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_678_4877)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.75 1C7.16421 1 7.5 1.33579 7.5 1.75V3H12.5V1.75C12.5 1.33579 12.8358 1 13.25 1C13.6642 1 14 1.33579 14 1.75V3H16.25C17.7688 3 19 4.23122 19 5.75V8.75C19 9.16421 18.6642 9.5 18.25 9.5H2.5V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H8.75C9.16421 17.5 9.5 17.8358 9.5 18.25C9.5 18.6642 9.16421 19 8.75 19H3.75C2.23122 19 1 17.7688 1 16.25V5.75C1 4.23122 2.23122 3 3.75 3H6V1.75C6 1.33579 6.33579 1 6.75 1ZM6 4.5H3.75C3.05964 4.5 2.5 5.05964 2.5 5.75V8H17.5V5.75C17.5 5.05964 16.9404 4.5 16.25 4.5H14V5.25C14 5.66421 13.6642 6 13.25 6C12.8358 6 12.5 5.66421 12.5 5.25V4.5H7.5V5.25C7.5 5.66421 7.16421 6 6.75 6C6.33579 6 6 5.66421 6 5.25V4.5ZM19.765 13.2047C20.0661 13.4891 20.0797 13.9638 19.7953 14.265L15.5453 18.765C15.4014 18.9173 15.2005 19.0025 14.991 18.9999C14.7815 18.9974 14.5827 18.9074 14.4425 18.7517L12.1925 16.2517C11.9154 15.9438 11.9404 15.4696 12.2483 15.1925C12.5562 14.9154 13.0304 14.9404 13.3075 15.2483L15.0133 17.1436L18.7047 13.235C18.9891 12.9339 19.4638 12.9203 19.765 13.2047Z'
        fill='#07AF17'
      />
    </g>
    <defs>
      <clipPath id='clip0_678_4877'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const Star = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.0928 2.52324C9.99905 2.47488 9.86181 2.50026 9.79335 2.64522L8.00799 6.42557C7.76215 6.94613 7.27807 7.32297 6.69953 7.41082L2.70736 8.01703C2.66367 8.02366 2.61758 8.04593 2.57857 8.08775C2.47149 8.20255 2.47467 8.39827 2.58316 8.50878L5.47192 11.4514C5.87611 11.8631 6.05323 12.4463 5.96057 13.0109L5.27863 17.1659C5.2674 17.2343 5.27853 17.3035 5.30766 17.3614C5.3787 17.5027 5.51526 17.5255 5.60897 17.474L9.17967 15.5123C9.69201 15.2308 10.3079 15.2308 10.8202 15.5123L14.3909 17.474C14.434 17.4977 14.48 17.5045 14.5234 17.4967C14.5864 17.4854 14.6553 17.4449 14.7056 17.3752C14.754 17.3081 14.7706 17.2347 14.7603 17.1681L14.0393 13.0109C13.9466 12.4463 14.1238 11.8631 14.5279 11.4514L17.4167 8.50878C17.4568 8.46792 17.4872 8.40957 17.4968 8.34084C17.5227 8.15465 17.3972 8.03293 17.2925 8.01703L13.3003 7.41082C12.7218 7.32297 12.2377 6.94613 11.9919 6.42557L10.2065 2.64522C10.1788 2.58657 10.1367 2.54586 10.0928 2.52324ZM8.437 2.00466C8.85086 1.12835 9.89685 0.734429 10.7804 1.1901C11.1257 1.36818 11.3985 1.65664 11.5629 2.00466L13.3482 5.78501C13.3898 5.87307 13.4613 5.91807 13.5255 5.92782L17.5177 6.53403C18.4915 6.6819 19.1133 7.60658 18.9825 8.54743C18.9296 8.92748 18.7578 9.28392 18.4871 9.5596L15.5984 12.5022C15.5379 12.5637 15.5029 12.662 15.5191 12.7656L16.2401 16.9229C16.4008 17.902 15.7151 18.807 14.788 18.9732C14.4037 19.042 14.0097 18.976 13.6686 18.7887L10.0979 16.8269C10.0354 16.7926 9.96447 16.7926 9.90194 16.8269L6.33123 18.7887C5.46031 19.2671 4.40376 18.9024 3.96767 18.0356C3.79485 17.692 3.7363 17.3015 3.79843 16.9229L4.48038 12.7679C4.49751 12.6635 4.4624 12.5642 4.40151 12.5022L1.51275 9.5596C0.840839 8.87517 0.828048 7.76534 1.48168 7.0646C1.74558 6.78168 2.09641 6.59261 2.48217 6.53403L6.47434 5.92782C6.53853 5.91807 6.61006 5.87307 6.65165 5.78501L8.437 2.00466Z'
      fill='#F57C00'
    />
  </svg>
)

export const TestIcon = () => (
  <svg
    width='14'
    height='15'
    viewBox='0 0 14 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.38413 3.03685H7.85239C8.24984 3.03685 8.52203 2.6436 8.37463 2.28174L7.99366 1.34663C7.90843 1.13708 7.7017 1 7.47142 1H4.76462C4.53482 1 4.32762 1.13754 4.24238 1.34663L3.86189 2.28174C3.71449 2.6436 3.98668 3.03685 4.38413 3.03685Z'
      fill='#FFB800'
    />
    <path
      d='M12.7209 8.27831C12.3488 7.9183 11.7508 7.9183 11.3788 8.27831L10.9775 8.67433L12.3206 9.98607L12.7209 9.59375C13.0929 9.22912 13.0929 8.64294 12.7209 8.27831Z'
      fill='#FFB800'
    />
    <path
      d='M10.4791 9.16455L8.18108 11.4169C8.12928 11.4631 8.09631 11.5277 8.0869 11.597L7.90795 12.6124C7.87028 12.8385 8.06806 13.0324 8.29881 12.9955L9.33952 12.8247C9.40545 12.8108 9.47138 12.7785 9.51847 12.7324L11.8212 10.4754L10.4791 9.16455Z'
      fill='#FFB800'
    />
    <path
      d='M9.68361 2.01953H9.02857L9.03092 2.02553C9.18727 2.40816 9.13923 2.84156 8.90331 3.18312C8.66738 3.52513 8.27464 3.7296 7.85317 3.7296H4.38444C3.96297 3.7296 3.57023 3.52559 3.33431 3.18312C3.09791 2.8411 3.05035 2.40816 3.20622 2.02507L3.20857 2.01953H2.55401C1.69224 2.01953 1 2.70263 1 3.54267V11.4768C1 12.3169 1.69224 13 2.55401 13H7.25888C7.20285 12.8412 7.1826 12.6709 7.21085 12.5006L7.39074 11.4791C7.41805 11.2728 7.53154 11.0591 7.70625 10.904L10.196 8.46286L10.8764 7.79037C10.9852 7.68514 11.1081 7.60298 11.2367 7.5319V3.54267C11.2376 2.70263 10.5407 2.01953 9.68361 2.01953ZM3.90128 9.69568H3.47229C3.23824 9.69568 3.04846 9.50967 3.04846 9.28028C3.04846 9.05088 3.23824 8.86488 3.47229 8.86488H3.90176C4.1358 8.86488 4.32558 9.05088 4.32558 9.28028C4.32558 9.50967 4.13533 9.69568 3.90128 9.69568ZM3.90128 7.17512H3.47229C3.23824 7.17512 3.04846 6.98911 3.04846 6.75972C3.04846 6.53032 3.23824 6.34432 3.47229 6.34432H3.90176C4.1358 6.34432 4.32558 6.53032 4.32558 6.75972C4.32558 6.98911 4.13533 7.17512 3.90128 7.17512ZM7.69683 9.69522H5.60128C5.36723 9.69522 5.17745 9.50921 5.17745 9.27981C5.17745 9.05042 5.36723 8.86441 5.60128 8.86441H7.69683C7.93087 8.86441 8.12065 9.05042 8.12065 9.27981C8.12065 9.50921 7.93135 9.69522 7.69683 9.69522ZM8.76533 7.17512H5.60033C5.36629 7.17512 5.17651 6.98911 5.17651 6.75972C5.17651 6.53032 5.36629 6.34432 5.60033 6.34432H8.76533C8.99937 6.34432 9.18915 6.53032 9.18915 6.75972C9.18915 6.98911 8.99937 7.17512 8.76533 7.17512Z'
      fill='#FFB800'
    />
  </svg>
)

export const HiddenEyeIcon = () => (
  <svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.92867 10.5001C8.45911 10.5001 8.96782 10.2894 9.34289 9.91436C9.71796 9.53929 9.92868 9.03058 9.92868 8.50015C9.92868 8.44158 9.926 8.38354 9.921 8.32622L7.75475 10.4925C7.81207 10.4975 7.86992 10.5001 7.92867 10.5001ZM14.5487 2.31372L13.7858 1.55157C13.759 1.5248 13.7227 1.50977 13.6848 1.50977C13.647 1.50977 13.6106 1.5248 13.5839 1.55157L11.6317 3.50425C10.5548 2.9539 9.34427 2.67872 8.0001 2.67872C4.56796 2.67872 2.00725 4.46622 0.31796 8.04122C0.250059 8.185 0.214844 8.34203 0.214844 8.50104C0.214844 8.66005 0.250059 8.81708 0.31796 8.96086C0.99296 10.3826 1.80576 11.5222 2.75635 12.3796L0.867246 14.268C0.840475 14.2948 0.825437 14.3311 0.825437 14.369C0.825437 14.4069 0.840475 14.4432 0.867246 14.47L1.62957 15.2323C1.65636 15.2591 1.69268 15.2741 1.73055 15.2741C1.76842 15.2741 1.80474 15.2591 1.83153 15.2323L14.5487 2.51586C14.562 2.50259 14.5725 2.48684 14.5797 2.46949C14.5869 2.45215 14.5906 2.43356 14.5906 2.41479C14.5906 2.39602 14.5869 2.37743 14.5797 2.36008C14.5725 2.34274 14.562 2.32698 14.5487 2.31372ZM4.78582 8.50015C4.78577 7.9573 4.92632 7.4237 5.1938 6.95132C5.46127 6.47894 5.84653 6.08389 6.31206 5.80466C6.77758 5.52543 7.30749 5.37154 7.85017 5.35798C8.39285 5.34442 8.92979 5.47166 9.40868 5.72729L8.54046 6.5955C8.19032 6.48339 7.81606 6.46989 7.45875 6.55648C7.10143 6.64307 6.77488 6.82641 6.51491 7.08638C6.25494 7.34635 6.0716 7.67291 5.98501 8.03022C5.89841 8.38753 5.91192 8.76179 6.02403 9.11193L5.15582 9.98015C4.91218 9.52493 4.78506 9.01646 4.78582 8.50015Z'
      fill='#DCDDDD'
    />
    <path
      d='M15.6819 8.03917C15.0533 6.71536 14.3052 5.6359 13.4374 4.80078L10.8635 7.37489C11.0805 7.94206 11.1286 8.55992 11.002 9.15383C10.8754 9.74774 10.5795 10.2923 10.1501 10.7217C9.72073 11.1511 9.17618 11.4469 8.58227 11.5735C7.98836 11.7001 7.3705 11.652 6.80333 11.4351L4.62012 13.6183C5.63297 14.087 6.75952 14.3213 7.99976 14.3213C11.4319 14.3213 13.9926 12.5338 15.6819 8.95882C15.7498 8.81504 15.785 8.65801 15.785 8.499C15.785 8.33999 15.7498 8.18295 15.6819 8.03917Z'
      fill='#DCDDDD'
    />
  </svg>
)

export const EyeIcon = () => (
  <svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.92868 8.50014C5.92868 9.03057 6.13939 9.53928 6.51446 9.91435C6.88953 10.2894 7.39824 10.5001 7.92868 10.5001C8.45911 10.5001 8.96782 10.2894 9.34289 9.91435C9.71796 9.53928 9.92868 9.03057 9.92868 8.50014C9.92868 7.96971 9.71796 7.461 9.34289 7.08593C8.96782 6.71085 8.45911 6.50014 7.92868 6.50014C7.39824 6.50014 6.88953 6.71085 6.51446 7.08593C6.13939 7.461 5.92868 7.96971 5.92868 8.50014ZM15.6822 8.03943C13.9894 4.47335 11.4305 2.67871 8.0001 2.67871C4.56796 2.67871 2.01082 4.47335 0.31796 8.04121C0.250059 8.18499 0.214844 8.34203 0.214844 8.50103C0.214844 8.66004 0.250059 8.81707 0.31796 8.96085C2.01082 12.5269 4.56975 14.3216 8.0001 14.3216C11.4322 14.3216 13.9894 12.5269 15.6822 8.95907C15.8197 8.66978 15.8197 8.33407 15.6822 8.03943ZM7.92868 11.643C6.19296 11.643 4.78582 10.2359 4.78582 8.50014C4.78582 6.76443 6.19296 5.35728 7.92868 5.35728C9.66439 5.35728 11.0715 6.76443 11.0715 8.50014C11.0715 10.2359 9.66439 11.643 7.92868 11.643Z'
      fill='#DCDDDD'
    />
  </svg>
)

export const GoldStarIcon = () => (
  <svg
    width='14'
    height='15'
    viewBox='0 0 14 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_23522_33890)'>
      <path
        d='M13.9308 5.27509L9.73388 4.66514L7.85774 0.86162C7.8065 0.757482 7.7222 0.67318 7.61806 0.621937C7.35689 0.493005 7.03951 0.600449 6.90893 0.86162L5.03279 4.66514L0.835862 5.27509C0.720153 5.29162 0.614362 5.34617 0.533366 5.42882C0.435446 5.52946 0.381488 5.66486 0.383347 5.80527C0.385207 5.94568 0.442733 6.0796 0.543284 6.17762L3.57982 9.13811L2.86242 13.3185C2.8456 13.4158 2.85636 13.5158 2.89348 13.6072C2.93061 13.6987 2.99261 13.7779 3.07246 13.8359C3.15231 13.8939 3.24682 13.9283 3.34526 13.9353C3.4437 13.9424 3.54213 13.9216 3.62941 13.8756L7.38333 11.9019L11.1373 13.8756C11.2397 13.9301 11.3588 13.9483 11.4728 13.9285C11.7604 13.8789 11.9538 13.6061 11.9042 13.3185L11.1869 9.13811L14.2234 6.17762C14.306 6.09662 14.3606 5.99083 14.3771 5.87512C14.4217 5.58585 14.2201 5.31807 13.9308 5.27509Z'
        fill='#FFB800'
      />
    </g>
    <defs>
      <clipPath id='clip0_23522_33890'>
        <rect
          width='14'
          height='14'
          fill='white'
          transform='translate(0 0.5)'
        />
      </clipPath>
    </defs>
  </svg>
)

export const TagIcon = () => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.25 1.125L0 12.375L6.875 19.25L18.125 8V1.125H11.25ZM14.375 6.125C14.1278 6.125 13.8861 6.05169 13.6805 5.91434C13.475 5.77699 13.3148 5.58176 13.2201 5.35335C13.1255 5.12495 13.1008 4.87361 13.149 4.63114C13.1972 4.38866 13.3163 4.16593 13.4911 3.99112C13.6659 3.8163 13.8887 3.69725 14.1311 3.64902C14.3736 3.60079 14.6249 3.62554 14.8534 3.72015C15.0818 3.81476 15.277 3.97498 15.4143 4.18054C15.5517 4.3861 15.625 4.62777 15.625 4.875C15.625 5.20652 15.4933 5.52446 15.2589 5.75888C15.0245 5.9933 14.7065 6.125 14.375 6.125Z'
      fill='#21272A'
    />
    <path
      d='M18.75 3V8.625L8.47266 18.9023L9.45313 19.875L20 9.25V3H18.75Z'
      fill='#21272A'
    />
  </svg>
)

export const EducationIcon = () => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_22306_18116)'>
      <path
        d='M10 14.9699L3.75 11.3984V15.243L10 18.7148L16.25 15.243V11.3984L10 14.9699Z'
        fill='#21272A'
      />
      <path
        d='M20.0098 8.0002L10 2.28027L-0.00976562 8.0002L10 13.7201L18.125 9.07715V15.5002H20V8.00566L20.0098 8.0002Z'
        fill='#21272A'
      />
    </g>
    <defs>
      <clipPath id='clip0_22306_18116'>
        <rect
          width='20'
          height='20'
          fill='white'
          transform='translate(0 0.5)'
        />
      </clipPath>
    </defs>
  </svg>
)

export const FilterIcon = () => {
  return (
    <svg
      width='35'
      height='35'
      viewBox='0 0 35 35'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.5 8.4961V26.5036H8.5V8.4961H26.5ZM28 6.99609L7 6.99619L7 28.0036L28 27.9961V6.99609ZM10.2625 9.9886H17.7625V24.9886H10.2625V9.9886Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const LeftArrowIcon = () => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.3125 3.36853V13.631C11.3125 13.9388 10.9875 14.1107 10.7656 13.9201L4.81563 8.78884C4.64531 8.64196 4.64531 8.35915 4.81563 8.21071L10.7656 3.07946C10.9875 2.88884 11.3125 3.06071 11.3125 3.36853Z'
        fill='#404041'
      />
    </svg>
  )
}

export const RightArrowIcon = () => {
  return (
    <svg
      width='8'
      height='11'
      viewBox='0 0 8 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.6875 0.368526L0.6875 10.631C0.6875 10.9388 1.0125 11.1107 1.23438 10.9201L7.18437 5.78884C7.35469 5.64196 7.35469 5.35915 7.18437 5.21071L1.23438 0.079463C1.0125 -0.111162 0.6875 0.0607128 0.6875 0.368526Z'
        fill='#404041'
      />
    </svg>
  )
}

const getIconEvent: Record<EVENT_TYPES, ReactNode | null> = {
  [EVENT_TYPES.TEACHING]: <Book />,
  [EVENT_TYPES.BUSY]: <CalendarDelete />,
  [EVENT_TYPES.HOLIDAY]: <Star />,
  [EVENT_TYPES.OTHER]: <CalendarAccept />,
  [EVENT_TYPES.LIVE_ONLINE]: null,
  [EVENT_TYPES.INACTIVE]: null,
};

const getIconEventDisable: Record<EVENT_TYPES, ReactNode | null> = {
  [EVENT_TYPES.TEACHING]: <Book color='#8CB5EA' />,
  [EVENT_TYPES.BUSY]: <CalendarDelete color='#EF8F8F' />,
  [EVENT_TYPES.HOLIDAY]: <Star />,
  [EVENT_TYPES.OTHER]: <CalendarAccept />,
  [EVENT_TYPES.LIVE_ONLINE]: null,
  [EVENT_TYPES.INACTIVE]: null,
}

export const getIconforEvent = (event: IEvent, isActive = true) => {
  if (event.source === CALENDAR_TYPE.LMS) {
    const icon = []
    if (event.type === EVENT_TYPES.HOLIDAY) {
      return []
    }
    if (event.isCaseStudy) {
      icon.push(<GoldStarIcon />)
    }
    if (event.isTest) {
      icon.push(<TestIcon />)
    }

    if (event.isKeyContentAfter || event.isKeyContentBefore) {
      icon.push(<FlagIcon />)
    }
    return icon
  } else {
    return isActive ? getIconEvent[event.type] : getIconEventDisable[event.type]
  }
}


export const IconFilter = ({ open }: { open: boolean }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.1303 2.26001C9.02243 2.26463 7.95215 2.66211 7.10984 3.38174C6.26753 4.10137 5.70782 5.09647 5.53028 6.19001H2.78028C2.68177 6.18599 2.58344 6.20143 2.4909 6.23546C2.39836 6.26948 2.31344 6.32141 2.241 6.38828C2.16855 6.45516 2.11 6.53566 2.0687 6.62518C2.02739 6.7147 2.00415 6.81149 2.00028 6.91001C2.00027 7.10985 2.07896 7.30166 2.21934 7.44391C2.35971 7.58615 2.55046 7.66738 2.75028 7.67001H5.45028H5.53028C5.67163 8.54879 6.06169 9.36871 6.65433 10.0328C7.24697 10.6969 8.0174 11.1773 8.8745 11.4174C9.73161 11.6574 10.6395 11.6469 11.4909 11.3872C12.3422 11.1275 13.1014 10.6294 13.6785 9.95186C14.2557 9.2743 14.6268 8.44561 14.7479 7.5638C14.8689 6.682 14.7349 5.78397 14.3617 4.97593C13.9884 4.16789 13.3916 3.48364 12.6417 3.00412C11.8919 2.52459 11.0204 2.26984 10.1303 2.27001V2.26001ZM10.1303 10.09C9.50289 10.09 8.88961 9.90383 8.36809 9.55507C7.84657 9.2063 7.44027 8.71062 7.20064 8.1308C6.96101 7.55097 6.89882 6.91308 7.02195 6.29789C7.14507 5.68269 7.44798 5.11787 7.89231 4.67494C8.33665 4.23201 8.90242 3.93089 9.518 3.80971C10.1336 3.68852 10.7713 3.75273 11.3503 3.99419C11.9294 4.23566 12.4238 4.64352 12.7709 5.16614C13.118 5.68875 13.3023 6.30262 13.3003 6.93001C13.2976 7.76901 12.9625 8.57275 12.3683 9.16508C11.7741 9.75741 10.9693 10.09 10.1303 10.09ZM16.6403 7.68001C16.4414 7.68001 16.2506 7.60099 16.11 7.46034C15.9693 7.31969 15.8903 7.12892 15.8903 6.93001C15.8876 6.83163 15.9048 6.73371 15.9409 6.64216C15.977 6.5506 16.0312 6.46728 16.1004 6.39723C16.1695 6.32717 16.2521 6.27181 16.3431 6.23448C16.4342 6.19715 16.5319 6.17862 16.6303 6.18001H21.2203C21.4175 6.17999 21.6067 6.25764 21.7471 6.39613C21.8875 6.53463 21.9677 6.72284 21.9703 6.92001C21.9703 7.11985 21.8916 7.31166 21.7512 7.45391C21.6109 7.59615 21.4201 7.67738 21.2203 7.68001H16.6403ZM21.2203 16.31H18.5503H18.4803C18.2954 15.1472 17.679 14.0969 16.754 13.3684C15.829 12.6399 14.6635 12.2868 13.4897 12.3796C12.316 12.4723 11.2203 13.004 10.4212 13.8688C9.62215 14.7335 9.17836 15.8676 9.17836 17.045C9.17836 18.2224 9.62215 19.3565 10.4212 20.2213C11.2203 21.086 12.316 21.6177 13.4897 21.7105C14.6635 21.8032 15.829 21.4501 16.754 20.7216C17.679 19.9932 18.2954 18.9428 18.4803 17.78H18.5603H21.2303C21.4292 17.78 21.62 17.701 21.7606 17.5603C21.9013 17.4197 21.9803 17.2289 21.9803 17.03C21.97 16.8355 21.8855 16.6523 21.744 16.5183C21.6026 16.3843 21.4151 16.3097 21.2203 16.31ZM13.8703 20.25C13.2417 20.2579 12.6249 20.0788 12.0984 19.7353C11.5718 19.3919 11.1593 18.8996 10.9132 18.3211C10.6671 17.7426 10.5986 17.104 10.7164 16.4865C10.8342 15.8689 11.1329 15.3004 11.5746 14.853C12.0163 14.4057 12.581 14.0998 13.197 13.9742C13.813 13.8486 14.4524 13.909 15.034 14.1477C15.6155 14.3864 16.113 14.7926 16.4631 15.3148C16.8133 15.8369 17.0002 16.4514 17.0003 17.08C16.9978 17.9131 16.6684 18.7119 16.0831 19.3047C15.4978 19.8975 14.7032 20.2369 13.8703 20.25ZM7.36028 17.83H2.78028C2.67759 17.8342 2.57514 17.8172 2.47929 17.7801C2.38344 17.743 2.29624 17.6866 2.2231 17.6144C2.14996 17.5422 2.09244 17.4557 2.05411 17.3603C2.01578 17.265 1.99746 17.1627 2.00028 17.06C2.00287 16.8619 2.08272 16.6726 2.22282 16.5325C2.36291 16.3924 2.55218 16.3126 2.75028 16.31H7.33028C7.42869 16.3086 7.52637 16.3272 7.61743 16.3645C7.7085 16.4018 7.79108 16.4572 7.8602 16.5272C7.92932 16.5973 7.98357 16.6806 8.01967 16.7722C8.05577 16.8637 8.07299 16.9616 8.07028 17.06C8.07578 17.2556 8.0046 17.4456 7.87196 17.5895C7.73931 17.7333 7.55569 17.8197 7.36028 17.83Z" fill={open ? 'white' : '#99A1B7'} />
    </svg>
  )
}
